module.exports = __webpack_public_path__ + "img/13.8621f660.gif";